import { render, staticRenderFns } from "./ProductPresentation.vue?vue&type=template&id=6c101540&"
import script from "./ProductPresentation.vue?vue&type=script&lang=js&"
export * from "./ProductPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports